"use client";
import { useRef, useState } from "react";
import Accordion from "./Accordion";
import TourMap from "./TourMap";

type ItineraryItem = {
  title: string;
  description: string;
};

type MarkdownImage = {
  filename: string;
  url: string;
  title?: string;
};

type MapAccordionProps = {
  itinerary: ItineraryItem[];
  images: MarkdownImage[];
  title: string;
  map: string | null;
};

export default function MapAccordion({
  itinerary,
  images,
  title,
  map,
}: MapAccordionProps) {
  const [focusedId, setFocusedId] = useState<number | null>(null);
  const [showMap, setShowMap] = useState(false);
  const mapRef = useRef(null);

  return (
    <>
      <Accordion
        itinerary={itinerary}
        images={images}
        title={title}
        focusedId={focusedId}
        setFocusedId={(id: number) => setFocusedId(id)}
        mapRef={mapRef}
      />
      {map && (
        <>
          <h3 className='font-kalam font-bold mt-14 text-4xl md:text-5xl text-center mb-10'>
            Mapa výletu
          </h3>
          <TourMap
            ref={mapRef}
            setFocusedId={(id: number) => setFocusedId(id)}
            tilesetId={map}
            showMap={showMap}
            setShowMap={setShowMap}
          />
        </>
      )}
    </>
  );
}
